import * as ApiNames from 'self-service-api/constants/ApiNames';
import { validateProperty } from 'ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty';
export const validateApiName = apiName => {
  const apiNameValues = Object.values(ApiNames);
  const isValidApiName = apiNameValues.indexOf(apiName) !== -1;
  return validateProperty(isValidApiName, `expected apiName to be one of ${apiNameValues} but got ${apiName}`, 'apiName');
};